module.exports = __webpack_public_path__ + "img/logo.166e9ef7.svg";